/**
 * For use in the delivery-detail component
 */
export class FishTicket {

    //Unique identifier for this ticket
    fishTicketID: string = '';

    ticketNumber: string = '';

    buyer: string = ''; // Groundfish only

    unloadingID: string = ''; // HMS only

    deliveryDate: Date = new Date(); // Groundfish only

    constructor(num: string, buyer: string) {
        this.ticketNumber = num;
        this.buyer = buyer;
    }
}
